var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3.37277 8.43181C4.30412 8.43181 5.05913 7.6768 5.05913 6.74545C5.05913 5.81409 4.30412 5.05908 3.37277 5.05908C2.44141 5.05908 1.6864 5.81409 1.6864 6.74545C1.6864 7.6768 2.44141 8.43181 3.37277 8.43181Z",
    stroke: "currentColor",
    strokeWidth: 0.919835,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.27499 12.2261C10.2063 12.2261 10.9614 11.4711 10.9614 10.5398C10.9614 9.6084 10.2063 8.85339 9.27499 8.85339C8.34363 8.85339 7.58862 9.6084 7.58862 10.5398C7.58862 11.4711 8.34363 12.2261 9.27499 12.2261Z",
    stroke: "currentColor",
    strokeWidth: 0.919835,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.27499 4.6375C10.2063 4.6375 10.9614 3.88249 10.9614 2.95113C10.9614 2.01978 10.2063 1.26477 9.27499 1.26477C8.34363 1.26477 7.58862 2.01978 7.58862 2.95113C7.58862 3.88249 8.34363 4.6375 9.27499 4.6375Z",
    stroke: "currentColor",
    strokeWidth: 0.919835,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.85691 3.86285L4.79089 5.83379",
    stroke: "currentColor",
    strokeWidth: 0.919835,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.79089 7.65698L7.85691 9.62792",
    stroke: "currentColor",
    strokeWidth: 0.919835,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShare;